import { Search } from '../../icons';
import { styled } from '../../styles';
import { TextField } from '../TextField';

export const SelectSearchInput = styled(TextField, {
  shouldForwardProp: (propName) => propName !== 'sizeText',
})(({ theme, size }) => ({
  width: '100%',
  outline: 'none',
  color: theme.palette.text1,

  height: 40,
  '.MuiInputBase-root': {
    height: 40,
  },
  '.MuiInputBase-input': {
    padding: theme.spacing(0),
  },

  '&::placeholder': {
    color: theme.palette.text3,
    ...(size === 'small'
      ? theme.typography.label3
      : (theme.typography.body2 as React.CSSProperties)),
  },
  '&:placeholder-shown': {
    textOverflow: 'ellipsis',
  },
}));

export const SelectSearchWrapper = styled.div(({ theme }) => ({
  padding: theme.spacing(0, 2, 2),
  color: theme.palette.text3,
}));

export const SelectSearchIcon = styled(Search)(({ theme }) => ({
  width: '24px',
  height: '24px',
  left: theme.spacing(4),
  zIndex: 1,
  fill: theme.palette.text4,
}));
